// import
import Dashboard from "./views/Dashboard";
import ConsultantDashboard from "./views/ConsultantDashboard";
import Clients from "./views/Clients";
import Consultants from "./views/Consultants";
import Users from "./views/Users";
import Appointments from "./views/Appointments";
import Files from "./views/Files";
import Reports from "./views/Reports";

import Activities from "./views/Activities";
import Settings from "./views/Settings";
import FormBuilder from "./views/FormBuilder";
import Profile from "./views/Profile";
import MyClients from "./views/MyClients";


import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  ActivityIcon,
} from "./components/Icons/Icons";

var dashRoutes = [
  // Main Routes - همه مسیرها بدون پیشوند
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "داشبورد",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/consultant-dashboard",
    name: "ConsultantDashboard",
    rtlName: "داشبورد مشاور",
    icon: <HomeIcon color="inherit" />,
    component: ConsultantDashboard,
    layout: "/rtl",
    roles: ["consultant"], // فقط برای مشاوران
  },
  {
    path: "/clients",
    name: "Clients",
    rtlName: "مراجعان",
    icon: <StatsIcon color="inherit" />,
    component: Clients,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/appointments",
    name: "Appointments",
    rtlName: "ملاقات‌ها",
    icon: <CreditIcon color="inherit" />,
    component: Appointments,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/my-appointments",
    name: "MyAppointments",
    rtlName: "ملاقات‌های من",
    icon: <CreditIcon color="inherit" />,
    component: Appointments, // استفاده از همان کامپوننت با فیلتر مشاور
    layout: "/rtl",
    roles: ["consultant"], // فقط برای مشاوران
  },
  {
    path: "/consultants",
    name: "Consultants",
    rtlName: "مشاوران",
    icon: <PersonIcon color="inherit" />,
    component: Consultants,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/files",
    name: "Files",
    rtlName: "فایل‌ها",
    icon: <DocumentIcon color="inherit" />,
    component: Files,
    layout: "/rtl",
    roles: [ "consultant"], // برای مدیران و مشاوران
  },
  {
    path: "/activities",
    name: "Activities",
    rtlName: "فعالیت‌ها",
    icon: <ActivityIcon color="inherit" />,
    component: Activities,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/reports",
    name: "Reports",
    rtlName: "گزارشات",
    icon: <DocumentIcon color="inherit" />,
    component: Reports,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  
  {
    path: "/users",
    name: "Users",
    rtlName: "کاربران",
    icon: <PersonIcon color="inherit" />,
    component: Users,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/settings",
    name: "setting",
    rtlName: "تنظیمات",
    icon: <DocumentIcon color="inherit" />,
    component: Settings,
    layout: "/rtl",
    roles: ["admin", "manager"], // فقط برای مدیران
  },
  {
    path: "/form-builder",
    name: "FormBuilder",
    rtlName: "فرم‌ساز",
    icon: <DocumentIcon color="inherit" />,
    component: FormBuilder,
    layout: "/rtl",
    roles: ["admin", "manager"],
  },
  
  
  {
    path: "/my-clients",
    name: "MyClients",
    rtlName: "مراجعین من",
    icon: <PersonIcon color="inherit" />,
    component: MyClients,
    layout: "/rtl",
    roles: ["consultant"], // فقط برای مشاوران
  },
  {
    name: "ACCOUNT PAGES",
    category: "account",
    rtlName: "حساب کاربری",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        rtlName: "پروفایل",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/rtl",
      },
      

    ],
  },
];
export default dashRoutes;
